import { useStorage } from "@vueuse/core"
import { AxiosResponse } from "axios"
import router from '@/router'
export class Version {
  private number = useStorage<Map<string, number>>(`version`, new Map())
  readonly _version: string = null;
  static readonly getVersion = () => {
    return new Version().version
  }
  private readonly openUpdate = () => {
    router.push('/update')
  }
  static readonly useVersion = (response: AxiosResponse) => {
    const version = response.headers['frontversion']
    if (version) {
      const instance = new Version()
      if (instance.number.value.get(version)) {
        if (instance.number.value.get(version) != Number(window.__BUILD_TIMESTAMP__)) {
          instance.openUpdate()
        } else {
          const values = Array.from(instance.number.value.values())
          const hasEqualValues = values.length !== new Set(values).size
          if (hasEqualValues) {
            instance.openUpdate()
          }
        }
      } else {
        instance.number.value.set(version, Number(window.__BUILD_TIMESTAMP__))
      }
    }
  }

  constructor() {
    let findTimestamp = 0, findVersion = null
    this.number.value.forEach((value, key) => {
      if (value > findTimestamp) {
        findTimestamp = value
        findVersion = key
      }
    })
    this._version = findVersion || '0.0.0'

  }
  get version() {
    return this._version
  }
}

